// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wp-block .buildable-block {\n  background-size: cover;\n  background-position: center;\n}\n.wp-block .buildable-block.bg-fixed {\n  background-attachment: fixed;\n}\n.wp-block .buildable-block.size-tall {\n  min-height: 60vh;\n}\n.wp-block .buildable-block.size-full {\n  min-height: 100vh;\n}\n.wp-block .buildable-block.remove-padding-top {\n  padding-top: 0;\n}\n.wp-block .buildable-block.remove-padding-bottom {\n  padding-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
